import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { px as _px, cssRef as _cssRef, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("search-bar__input-0cgcs9", {
  border: "none",
  maxWidth: "100%",
  padding: "8px",
  height: "44px",
  backgroundColor: "transparent",
  paddingLeft: "42px",
  borderRadius: "24px",
  "&:not(:placeholder-shown)": {
    border: "none"
  },
  "@media (max-width: 1200px)": {
    maxWidth: "100%"
  }
});
import React from 'react';
import IconSearch from '../../../images/svg/search.svg';
import { borderRadius, breakpoints } from '../tokens';
import { colors } from '../colors';
import Input from '../input';

/*
* A logic-less search bar with an autocomplete dropdown
* */
interface SearchBarProps {
  value: string;
  onChange: (value: string) => void;
  suggestions?: {
    label: string;
    data: unknown;
  }[];
  onSuggestionClick?: (data: unknown) => void;
  bordered?: boolean;
  white?: boolean;
  nativeAutoComplete?: boolean;
  placeholder: string;
  onFocus?: () => void;
  disabled?: boolean;
  autoFocus?: boolean;
}
const SearchBar = ({
  value,
  onChange,
  suggestions,
  onSuggestionClick,
  bordered,
  white,
  placeholder,
  onFocus,
  disabled,
  autoFocus,
  nativeAutoComplete
}: SearchBarProps): JSX.Element => {
  const suggestionsRef = React.useRef<HTMLDivElement>(null);
  const inputRef = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    let animationFrameId: number;
    const focusInput = (): void => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    };
    const handleAnimationFrame = (): void => {
      focusInput();
    };
    if (autoFocus && inputRef.current) {
      animationFrameId = requestAnimationFrame(handleAnimationFrame);
    }
    return () => {
      cancelAnimationFrame(animationFrameId);
    };
  }, [autoFocus]);
  return <div className="search-bar__div-2d5oa5">
            <div className="search-bar__div-294v8d">
                <div className="search-bar__div-18lbao" style={{
        "--static-styles-380edn88_border": _px(bordered ? `2px solid ${colors.primaryOrange}` : ''),
        "--static-styles-0667m1dm_backgroundColor": _px(white ? colors.shadesWhite : colors.grey100),
        "--static-styles-05n30v19_borderBottomLeftRadius": _px(suggestions && suggestions.length > 0 ? '0px' : '24px'),
        "--static-styles-1ktjf5f6_borderBottomRightRadius": _px(suggestions && suggestions.length > 0 ? '0px' : '24px')
      }}>
                    <div className="search-bar__div-1c7q6z">
                        <IconSearch aria-hidden="true" focusable="false" className="search-bar__iconsearch-0kxfy2" style={{
            "--static-styles-04v1n5yw_stroke": _px(bordered ? colors.primaryOrange : colors.shadesBlack)
          }} />
                        <div className="search-bar__div-3mhsa7">
                            <Input {..._mergeComponentProps({
              autoComplete: nativeAutoComplete ? 'on' : 'off',
              ref: inputRef,
              hideLabel: true,
              css: _staticStyles,
              disabled: disabled,
              name: "q",
              type: "text",
              placeholder: placeholder,
              value: value,
              onChange: e => {
                if ('value' in e.target && typeof e.target.value === 'string') {
                  onChange(e.target.value);
                }
              },
              onFocus: onFocus,
              onKeyDown: e => {
                if (e.key === 'ArrowDown' && suggestions && suggestions.length > 0) {
                  e.preventDefault();
                  suggestionsRef.current?.querySelector('button')?.focus();
                } else if (e.key === 'ArrowUp' && suggestions && suggestions.length > 0) {
                  e.preventDefault();
                  if (suggestionsRef.current) {
                    const selector = suggestionsRef.current?.querySelector('button:last-child');
                    if (selector && 'focus' in selector && typeof selector.focus === 'function') {
                      selector.focus();
                    }
                  }
                }
              }
            })} />
                        </div>
                        <div style={{
            display: value ? 'unset' : 'none'
          }} className="search-bar__div-0w03ql">
                            <button type="button" aria-label="Clear Search" aria-disabled={!value} onClick={() => {
              onChange('');
              if (inputRef.current) {
                inputRef.current.focus();
              }
            }} className="search-bar__button-1hwe55">
                                <div className="search-bar__div-3mwb8c">
                                    <div className="search-bar__div-28g4en" />
                                    <div className="search-bar__div-2h39u7" />
                                </div>
                            </button>
                        </div>
                    </div>
                    {suggestions && suggestions.length > 0 && <div className="suggestions search-bar__div-3ftssy" ref={suggestionsRef} tabIndex={0} role="listbox">
                            {suggestions.map(item => <button key={item.label} type="button" aria-label={item.label} role="option" aria-selected="false" onClick={() => {
            onChange(item.label);
            if (onSuggestionClick) {
              onSuggestionClick(item.data);
            }
          }} onKeyDown={e => {
            if (e.key === 'ArrowDown') {
              e.preventDefault();
              const currentSuggestionElement = e.currentTarget;
              const nextSuggestionElement = currentSuggestionElement.nextElementSibling as HTMLButtonElement | undefined;
              if (nextSuggestionElement) {
                nextSuggestionElement.focus();
              } else if (inputRef.current) {
                inputRef.current.focus();
              }
            }
            if (e.key === 'ArrowUp') {
              e.preventDefault();
              const currentSuggestionElement = e.currentTarget;
              const prevSuggestionElement = currentSuggestionElement.previousElementSibling as HTMLButtonElement | undefined;
              if (prevSuggestionElement) {
                prevSuggestionElement.focus();
              } else if (inputRef.current) {
                inputRef.current.focus();
              }
            }
          }} className="search-bar__button-2l10u1">
                                    <span className="search-bar__span-33n458">
                                        {item.label}
                                    </span>
                                </button>)}
                        </div>}
                </div>
            </div>
        </div>;
};
export default SearchBar;